export * from './usermanagement.component';
export * from './usermanagement.service';



// WEBPACK FOOTER //
// ./src/app/usermanagement/index.ts